var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_c('v-btn',{staticClass:"my-10",attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.buttonIsDisabled},on:{"click":_vm.downloadCSV}},[_vm._v(" Download CSV ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }